import { Provider } from '@angular/core';

import { SYSTEM_ADMINS_STORE } from '@system-admins/stores/system-admins.store';

export const SYSTEM_ADMINS_PROVIDERS: Provider[] = [SYSTEM_ADMINS_STORE];
